import React from 'react';

import { fg } from '@atlaskit/platform-feature-flags/fg';
import { BRIDGE_SOURCE } from '@atlaskit/rovo-triggers/extension-context-bridge/constants';
import { Subscriber } from '@atlaskit/rovo-triggers/main';

import { useChatContextStoreActions } from './store';

export const ChatContextSubscriber = (): React.JSX.Element => {
	const {
		setEditorContext,
		setBrowserContext,
		setDashboardContext,
		setAIFeatureContext,
		setJiraCreateContext,
		setArtifactContext,
		mergeDatabaseContext,
		setPageSmartLinks,
	} = useChatContextStoreActions();

	return (
		<Subscriber
			topic="ai-mate"
			onEvent={async (payload) => {
				// TODO https://product-fabric.atlassian.net/browse/AIM-1989 implement experience tracker
				try {
					switch (payload.type) {
						case 'editor-context-payload':
							setEditorContext(payload.data, {
								relayed: payload.interactionSource === BRIDGE_SOURCE,
							});
							break;
						case 'browser-context-payload':
							setBrowserContext(payload.data);
							break;
						case 'dashboard-insights-actions':
							setDashboardContext(payload.data);
							break;
						case 'database-context-payload':
							mergeDatabaseContext(payload.data);
							break;
						case 'set-message-context': {
							setAIFeatureContext(payload.data);
							break;
						}
						case 'jira-create-context-payload': {
							setJiraCreateContext(payload.data);
							break;
						}
						case 'artifact-context-payload': {
							if (!fg('platform_forge_ui_artifact_rovo_chat_context')) {
								break;
							}
							setArtifactContext(payload.data);
							break;
						}
						case 'smartlinks-context-payload': {
							if (payload.status) {
								setPageSmartLinks(payload.data, payload.status);
							} else {
								setPageSmartLinks(payload.data);
							}
							break;
						}
						default:
					}
				} catch {}
			}}
		/>
	);
};
